import { GET_RIDEDETAILSPOLYLINE } from "resources/actionTypes";

export function getRideDetailsPolylines(id) {
    const data = id
    return {
      type: GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_REQUESTED,
      payload: data,
    };
  }
  